import { useEffect } from "react";
import Icons from "@hs/icons";
import Constants from "data/constants";
import Status from "components/Status";
import { useIntersectionObserver } from "hooks";

const threshold = 0.999; //HACK: Use .999 to avoid rounding errors in Microsoft Edge

const Pagination = ({
    node,
    onPaginate,
    className,
    style,
    status,
    icon,
    label,
}) => {
    const { setRef, entry } = useIntersectionObserver({
        root: node,
        rootMargin: "0px",
        threshold: 0.999,
    });
    const isIntersecting = entry.intersectionRatio >= threshold;
    useEffect(() => {
        if (isIntersecting) {
            onPaginate();
        }
    }, [isIntersecting, onPaginate]);
    return (
        <div
            ref={setRef}
            style={style}
            className={className}
            onClick={onPaginate}
        >
            {status !== Constants.OK ? (
                <Status status={status} />
            ) : (
                <>
                    <Icons.Library name={icon} />
                    <span>{label}</span>
                </>
            )}
        </div>
    );
};

export default Pagination;
